import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SidebarCollapsibleSection } from 'components/blocks/layout/sidebar-section';
import { SidebarTreeItem } from 'components/blocks/layout/sidebar-items';
import { IconName } from 'components/blocks/menu-icon/menu-icon';
import { useSidebar } from 'components/ui/sidebar';
import { DEFAULT_CONVERSATION_NAME } from 'utils/constants/chat-constants';
import { Draggable } from 'features/sidebar/Draggable';
import { SidebarItem } from 'components/blocks/layout/types/sidebar-conversation';

interface GroupChatsSectionProps {
    conversations: SidebarItem[];
    isSidebarLoading: boolean;
    allLoaded: boolean;
    loaderRef: React.RefObject<HTMLDivElement>;
    renderRightAction: (id: string, title: string) => React.ReactNode;
}

export const GroupChatsSection = ({
    conversations,
    isSidebarLoading,
    allLoaded,
    loaderRef,
    renderRightAction
}: GroupChatsSectionProps) => {
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const { isMobile, setOpenMobile } = useSidebar();
    const navigate = useNavigate();

    if (!conversations || (conversations.length === 0 && !isSidebarLoading)) return null;

    return (
        <SidebarCollapsibleSection
            title={t("GROUP_CHATS")}
            icon={'MessagesSquare' as IconName}
            defaultOpen={true}
        >
            <div className="flex flex-col gap-1">
                {conversations.map((item) => (
                    <Draggable key={item.ConversationId} id={item.ConversationId}>
                        <SidebarTreeItem
                            label={item.ConversationTitle || t(DEFAULT_CONVERSATION_NAME)}
                            isActive={pathname.includes(item.ConversationId)}
                            onClick={() => {
                                if (isMobile) setOpenMobile(false);
                                navigate(`/chat/${item.ConversationId}`);
                            }}
                            rightAction={renderRightAction(item.ConversationId, item.ConversationTitle)}
                        />
                    </Draggable>
                ))}

                {!allLoaded && (
                    <div ref={loaderRef} className="h-10 w-full flex items-center justify-center p-4">
                        {/* Independent Group Loader */}
                    </div>
                )}
            </div>
        </SidebarCollapsibleSection>
    );
};
